import {apiClient} from '@/services/base/BaseService';
import {IShop} from '@/models/IShop';

export async function getListShops(organizationId: number) {
    const res = await apiClient.get(`organizations/${organizationId}/shops`
    );

    return res.data.data as IShop[];
}

